module.exports = __webpack_public_path__ + "img/8_23.d164e623.png";